import { CloseIcon } from "@icons";
import { Button } from "@design-system/Button/Button";

interface Props {
    onClick: () => void;
    ariaLabel?: string;
    className?: string;
}

export const RemoveSpreadsheetRowButton = ({
    onClick,
    ariaLabel = "Remove row",
    className,
}: Props) => (
    <Button
        type="button"
        variant="ghost"
        iconOnly
        aria-label={ariaLabel}
        className={className}
        size="md"
        onClick={onClick}
    >
        <CloseIcon />
    </Button>
);
